<ng-content select="eui-page-hero-header"></ng-content>
<ng-content select="eui-page-header"></ng-content>
<ng-content select="eui-page-content"></ng-content>
<ng-content select="eui-page-footer"></ng-content>
<ng-content select="eui-page-columns"></ng-content>
